module.exports = __webpack_public_path__ + "static/media/seminar.7ae05ad3.png";